import {get, post, del, put} from '@/api';
import * as REMINDER from '../constants/reminder';
import queryString from "query-string";

export default {
  [REMINDER.ACTION_LIST_REMINDERS]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});

    return get(`/reminder?${qs}`).then((res) => {
      commit(REMINDER.MUTATE_LIST_REMINDER, res.data);
    })
  },

  [REMINDER.ACTION_ADD]: ({commit}, payload) => {
    return post('/reminder', payload);
  },

  [REMINDER.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/reminder/${payload.id}`);
  },

  [REMINDER.ACTION_UPDATE]: ({commit}, payload) => {
    return put(`/reminder/${payload.id}`, payload);
  }
}



// WEBPACK FOOTER //
// ./src/store/reminder/actions.js